import React from 'react';
import PropTypes from 'prop-types';

export class JsonBlob extends React.Component {
  static initClass() {
    this.propTypes = {
      name: PropTypes.string,
      value: PropTypes.any
    };
  }

  render() {
    const json = JSON.stringify(this.props.value);
    return <input type="hidden" name={this.props.name} value={json} />;
  }
}
JsonBlob.initClass();
